var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { AppConstant } from 'constants/app.constant';
import { createAction, handleActions } from 'redux-actions';
import { getExamGroupIdByAllowPartialCreditFlag, mapNGNItemHesiNGToNGNItem } from 'reports/hesi-ng/helpers';
import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';
var defaultExamData = {
    accountInfo: [],
    caseStudyVtwIdInfo: [],
    examGroupInfo: [],
    examInfo: [],
    examQuestionInfo: [],
    studyPacketInfo: [],
    testTakerData: []
};
var defaultExamSummary = {
    meanScore: 0,
    studentBelowAcceptableScore: 0,
    numberTestTaker: 0,
    examName: null,
    acceptableScore: 0,
    compareHesiToNational: 0,
    productName: null,
    showNationalScore: false,
    showBelowAcceptableScore: false,
    showMeanScoreChart: false,
    isExamTypeCat: false,
    recommendedScore: 0,
    showPerformanceLevel: true
};
export var defaultExamType = {
    value: '',
    name: '',
    productName: '',
    examGroupAssessmentType: '',
    acceptableScore: 0,
    editionId: 0,
    examName: '',
    nationalHesiAverage: 0,
    productId: 0,
    recommendedScore: 0,
    scoreHighRange: 0,
    scoreMethodId: 0,
    scoreMethodName: '',
    examType: ''
};
export var defaultStudentExamSummaryResult = {
    summary: {
        overall: {
            scores: {
                current: {
                    hesi: 0,
                    conversion: 0
                },
                range: {
                    acceptable: 0,
                    nationalAverage: 0,
                    recommended: 0
                }
            },
            examDate: 0,
            questionsCount: 0,
            questionsSeen: 0,
            questionsCompleted: 0,
            questionsCorrect: 0
        },
        concepts: []
    },
    students: []
};
var defaultSelectedStudentExam = {
    key: '',
    name: '',
    examId: null,
    examName: '',
    examType: '',
    examDate: null,
    examGroupId: null,
    examVersion: null,
    guid: null,
    categoryDisplayName: null
};
export var initialState = Immutable({
    ngnItems: [],
    examData: defaultExamData,
    examGroupIdSelected: [],
    studentListPerformance: [],
    isFetchingStudentsListPerformance: false,
    performanceLevelStudentFilter: null,
    examResultSummary: defaultExamSummary,
    selectedExamName: '',
    selectedStudent: null,
    selectedExamType: defaultExamType,
    selectedTaxonomyName: '',
    selectedStudentTaxonomyName: '',
    selectedStudentRoleTaxonomyName: null,
    weakestCategoriesAndTableSortInteraction: null,
    studentWeakestCategoriesAndTableSortInteraction: null,
    studentExamSummaryResult: defaultStudentExamSummaryResult,
    isStudentExamSummaryResultLoading: false,
    isFilterExamModalOpen: false,
    examGroupOptions: [],
    allExamGroupOptions: [],
    examTypeOptions: [],
    studentExamGroupInfo: null,
    selectedStudentExam: defaultSelectedStudentExam,
    orderItemSummaryData: { conceptData: [], testTakerData: [] },
    externalCourseSectionId: null,
    orderItemSummaryMessage: '',
    isWeakestSubjectAreaCardAndTableSortInteraction: false,
    a2StudentPerformance: {},
    isHERItemDetailsLoading: false,
    isHesiNGCategoryDataLoading: false,
    isNGNTabDataLoading: false,
    isCategoryLegalDisclaimerDataLoading: false
});
var prefixActionName = 'HESI_NG';
var restoreState = createAction("".concat(prefixActionName, "/RESTORE"));
var setNGNItem = createAction("".concat(prefixActionName, "/SET_NGN_ITEM"));
var setExamData = createAction("".concat(prefixActionName, "/SET_EXAM_DATA"));
var setExamGroupInfo = createAction("".concat(prefixActionName, "/SET_EXAM_GROUP_INFO"));
var setExamGroupIdSelected = createAction("".concat(prefixActionName, "/SET_EXAM_GROUP_ID_SELECTED"));
var setStudentListPerformance = createAction("".concat(prefixActionName, "/SET_STUDENTS_LIST_PERFORMANCE"));
var setIsFetchingStudentsListPerformance = createAction("".concat(prefixActionName, "/SET_IS_FETCHING_STUDENTS_LIST_PERFORMANCE"));
var setPerformanceLevelStudentFilter = createAction("".concat(prefixActionName, "/SET_PERFORMANCE_LEVEL_STUDENT_FILTER"));
var setExamResultSummary = createAction("".concat(prefixActionName, "/SET_EXAM_RESULT_SUMMARY"));
var setSelectedExamName = createAction("".concat(prefixActionName, "/SET_SELECTED_EXAM_NAME"));
var setSelectedStudent = createAction("".concat(prefixActionName, "/SET_SELECTED_STUDENT"));
var setSelectedExamType = createAction("".concat(prefixActionName, "/SET_SELECTED_EXAM_TYPE"));
var setSelectedTaxonomyName = createAction("".concat(prefixActionName, "/SET_SELECTED_TAXONOMY_NAME"));
var setSelectedStudentTaxonomyName = createAction("".concat(prefixActionName, "/SET_SELECTED_STUDENT_TAXONOMY_NAME"));
var setSelectedStudentRoleTaxonomyName = createAction("".concat(prefixActionName, "/SET_SELECTED_STUDENT_ROLE_TAXONOMY_NAME"));
var setWeakestCategoriesAndTableSortInteraction = createAction("".concat(prefixActionName, "/SET_WEAKEST_CATEGORIES_AND_TABLE_SORT_INTERACTION"));
var setStudentWeakestCategoriesAndTableSortInteraction = createAction("".concat(prefixActionName, "/SET_STUDENT_WEAKEST_CATEGORIES_AND_TABLE_SORT_INTERACTION"));
var setStudentExamSummaryResult = createAction("".concat(prefixActionName, "/SET_STUDENT_EXAM_SUMMARY_RESULT"));
var setIsStudentExamSummaryResultLoading = createAction("".concat(prefixActionName, "/SET_IS_STUDENT_EXAM_SUMMARY_RESULT_LOADING"));
var setIsFilterExamModalOpen = createAction("".concat(prefixActionName, "/SET_IS_FILTER_EXAM_MODAL_OPEN"));
var setStudentExamGroupInfo = createAction("".concat(prefixActionName, "/SET_STUDENT_EXAM_GROUP_INFO"));
var setExamGroupOptions = createAction("".concat(prefixActionName, "/SET_EXAM_GROUP_OPTIONS"));
var setAllExamGroupOptions = createAction("".concat(prefixActionName, "/SET_ALL_EXAM_GROUP_OPTIONS"));
var setExamTypeOptions = createAction("".concat(prefixActionName, "/SET_EXAM_TYPE_OPTIONS"));
var setSelectedStudentExam = createAction("".concat(prefixActionName, "/SET_SELECTED_STUDENT_EXAM"));
var setOrderItemSummaryData = createAction("".concat(prefixActionName, "/SET_ORDER_ITEM_SUMMARY_DATA"));
var setExternalCourseSectionId = createAction("".concat(prefixActionName, "/SET_EXTERNAL_COURSE_SECTION_ID"));
var setOrderItemSummaryMessage = createAction("".concat(prefixActionName, "/SET_ORDER_ITEM_SUMMARY_MESSAGE"));
var setIsWeakestSubjectAreaCardAndTableSortInteraction = createAction("".concat(prefixActionName, "/SET_IS_WEAKEST_SUBJECT_AREA_CARD_AND_TABLE_SORT_INTERACTION"));
var setA2StudentPerformance = createAction("".concat(prefixActionName, "/SET_A2_STUDENT_PERFORMANCE"));
var setIsHERItemDetailsLoading = createAction("".concat(prefixActionName, "/SET_HER_ITEM_DETAILS_LOADING"));
var setIsHesiNGCategoryDataLoading = createAction("".concat(prefixActionName, "/SET_IS_HESI_NG_CATEGORY_DATA_LOADING"));
var setIsNGNTabDataLoading = createAction("".concat(prefixActionName, "/SET_IS_NGN_TAB_DATA_LOADING"));
var setIsCategoryLegalDisclaimerDataLoading = createAction("".concat(prefixActionName, "/SET_IS_CATEGORY_LEGAL_DISCLAIMER_DATA_LOADING"));
var actions = {
    restoreState: restoreState,
    setNGNItem: setNGNItem,
    setExamData: setExamData,
    setExamGroupInfo: setExamGroupInfo,
    setExamGroupIdSelected: setExamGroupIdSelected,
    setStudentListPerformance: setStudentListPerformance,
    setIsFetchingStudentsListPerformance: setIsFetchingStudentsListPerformance,
    setPerformanceLevelStudentFilter: setPerformanceLevelStudentFilter,
    setExamResultSummary: setExamResultSummary,
    setSelectedExamName: setSelectedExamName,
    setSelectedStudent: setSelectedStudent,
    setSelectedExamType: setSelectedExamType,
    setSelectedTaxonomyName: setSelectedTaxonomyName,
    setWeakestCategoriesAndTableSortInteraction: setWeakestCategoriesAndTableSortInteraction,
    setSelectedStudentTaxonomyName: setSelectedStudentTaxonomyName,
    setStudentWeakestCategoriesAndTableSortInteraction: setStudentWeakestCategoriesAndTableSortInteraction,
    setStudentExamSummaryResult: setStudentExamSummaryResult,
    setSelectedStudentRoleTaxonomyName: setSelectedStudentRoleTaxonomyName,
    setIsStudentExamSummaryResultLoading: setIsStudentExamSummaryResultLoading,
    setIsFilterExamModalOpen: setIsFilterExamModalOpen,
    setExamGroupOptions: setExamGroupOptions,
    setAllExamGroupOptions: setAllExamGroupOptions,
    setExamTypeOptions: setExamTypeOptions,
    setStudentExamGroupInfo: setStudentExamGroupInfo,
    setSelectedStudentExam: setSelectedStudentExam,
    setOrderItemSummaryData: setOrderItemSummaryData,
    setExternalCourseSectionId: setExternalCourseSectionId,
    setOrderItemSummaryMessage: setOrderItemSummaryMessage,
    setIsWeakestSubjectAreaCardAndTableSortInteraction: setIsWeakestSubjectAreaCardAndTableSortInteraction,
    setA2StudentPerformance: setA2StudentPerformance,
    setIsHERItemDetailsLoading: setIsHERItemDetailsLoading,
    setIsHesiNGCategoryDataLoading: setIsHesiNGCategoryDataLoading,
    setIsNGNTabDataLoading: setIsNGNTabDataLoading,
    setIsCategoryLegalDisclaimerDataLoading: setIsCategoryLegalDisclaimerDataLoading
};
var reducer = handleActions((_a = {},
    _a[actions.restoreState] = function (state, _a) {
        var payload = _a.payload;
        return state.merge(payload);
    },
    _a[actions.setNGNItem] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'ngnItems', payload);
    },
    _a[actions.setExamData] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'examData', payload);
    },
    _a[actions.setExamGroupInfo] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'examData', __assign(__assign({}, state === null || state === void 0 ? void 0 : state.examData), { examGroupInfo: payload }));
    },
    _a[actions.setExamGroupIdSelected] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'examGroupIdSelected', payload);
    },
    _a[actions.setStudentListPerformance] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentListPerformance', payload);
    },
    _a[actions.setIsFetchingStudentsListPerformance] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isFetchingStudentsListPerformance', payload);
    },
    _a[actions.setPerformanceLevelStudentFilter] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'performanceLevelStudentFilter', payload);
    },
    _a[actions.setExamResultSummary] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'examResultSummary', payload);
    },
    _a[actions.setSelectedExamName] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedExamName', payload);
    },
    _a[actions.setSelectedStudent] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedStudent', payload);
    },
    _a[actions.setSelectedExamType] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedExamType', payload);
    },
    _a[actions.setSelectedTaxonomyName] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedTaxonomyName', payload);
    },
    _a[actions.setSelectedStudentTaxonomyName] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedStudentTaxonomyName', payload);
    },
    _a[actions.setSelectedStudentRoleTaxonomyName] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedStudentRoleTaxonomyName', payload);
    },
    _a[actions.setWeakestCategoriesAndTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'weakestCategoriesAndTableSortInteraction', payload);
    },
    _a[actions.setStudentWeakestCategoriesAndTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentWeakestCategoriesAndTableSortInteraction', payload);
    },
    _a[actions.setStudentExamSummaryResult] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentExamSummaryResult', payload);
    },
    _a[actions.setIsStudentExamSummaryResultLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isStudentExamSummaryResultLoading', payload);
    },
    _a[actions.setIsFilterExamModalOpen] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isFilterExamModalOpen', payload);
    },
    _a[actions.setExamGroupOptions] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'examGroupOptions', payload);
    },
    _a[actions.setAllExamGroupOptions] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'allExamGroupOptions', payload);
    },
    _a[actions.setExamTypeOptions] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'examTypeOptions', payload);
    },
    _a[actions.setStudentExamGroupInfo] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentExamGroupInfo', payload);
    },
    _a[actions.setSelectedStudentExam] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedStudentExam', payload);
    },
    _a[actions.setOrderItemSummaryData] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'orderItemSummaryData', payload);
    },
    _a[actions.setExternalCourseSectionId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'externalCourseSectionId', payload);
    },
    _a[actions.setOrderItemSummaryMessage] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'orderItemSummaryMessage', payload);
    },
    _a[actions.setIsWeakestSubjectAreaCardAndTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isWeakestSubjectAreaCardAndTableSortInteraction', payload);
    },
    _a[actions.setA2StudentPerformance] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'a2StudentPerformance', payload);
    },
    _a[actions.setIsHERItemDetailsLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isHERItemDetailsLoading', payload);
    },
    _a[actions.setIsHesiNGCategoryDataLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isHesiNGCategoryDataLoading', payload);
    },
    _a[actions.setIsNGNTabDataLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isNGNTabDataLoading', payload);
    },
    _a[actions.setIsCategoryLegalDisclaimerDataLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isCategoryLegalDisclaimerDataLoading', payload);
    },
    _a), initialState);
var getHesiNGState = function (state) { return state[AppConstant.reduxResources.HESI_NG_STATE]; };
var getRemappedNgnItems = createSelector(getHesiNGState, function (state) {
    var examData = state.examData, _a = state.ngnItems, ngnItems = _a === void 0 ? [] : _a;
    var examGroupInfo = examData.examGroupInfo;
    var examGroupIdMap = getExamGroupIdByAllowPartialCreditFlag(examGroupInfo);
    return ngnItems.map(function (item) { return mapNGNItemHesiNGToNGNItem(item, {}, examGroupIdMap); });
});
var selectors = {
    getNGNItems: createSelector(getHesiNGState, function (state) { return state.ngnItems; }),
    getRemappedNgnItems: getRemappedNgnItems,
    getExamData: createSelector(getHesiNGState, function (state) { return state.examData; }),
    getExamGroupIdSelected: createSelector(getHesiNGState, function (state) { return state.examGroupIdSelected; }),
    getStudentListPerformance: createSelector(getHesiNGState, function (state) { return state.studentListPerformance; }),
    getIsFetchingStudentsListPerformance: createSelector(getHesiNGState, function (state) { return state.isFetchingStudentsListPerformanceTab; }),
    getPerformanceLevelStudentFilter: createSelector(getHesiNGState, function (state) { return state.performanceLevelStudentFilter; }),
    getExamResultSummary: createSelector(getHesiNGState, function (state) { return state.examResultSummary; }),
    getSelectedExamName: createSelector(getHesiNGState, function (state) { return state.selectedExamName; }),
    getSelectedStudent: createSelector(getHesiNGState, function (state) { return state.selectedStudent; }),
    getHesiExamsResultsFilter: createSelector(getHesiNGState, function (state) { return state.hesiExamsResultsFilter; }),
    getSelectedExamType: createSelector(getHesiNGState, function (state) { return state.selectedExamType; }),
    getWeakestCategoriesAndTableSortInteraction: createSelector(getHesiNGState, function (state) { return state.weakestCategoriesAndTableSortInteraction; }),
    getSelectedTaxonomyName: createSelector(getHesiNGState, function (state) { return state.selectedTaxonomyName; }),
    getSelectedStudentTaxonomyName: createSelector(getHesiNGState, function (state) { return state.selectedStudentTaxonomyName; }),
    getSelectedStudentRoleTaxonomyName: createSelector(getHesiNGState, function (state) { return state.selectedStudentRoleTaxonomyName; }),
    getStudentWeakestCategoriesAndTableSortInteraction: createSelector(getHesiNGState, function (state) { return state.studentWeakestCategoriesAndTableSortInteraction; }),
    getStudentExamSummaryResult: createSelector(getHesiNGState, function (state) { return state.studentExamSummaryResult; }),
    getIsStudentExamSummaryResultLoading: createSelector(getHesiNGState, function (state) { return state.isStudentExamSummaryResultLoading; }),
    getIsFilterExamModalOpen: createSelector(getHesiNGState, function (state) { return state.isFilterExamModalOpen; }),
    getExamGroupOptions: createSelector(getHesiNGState, function (state) { return state.examGroupOptions; }),
    getAllExamGroupOptions: createSelector(getHesiNGState, function (state) { return state.allExamGroupOptions; }),
    getExamTypeOptions: createSelector(getHesiNGState, function (state) { return state.examTypeOptions; }),
    getStudentExamGroupInfo: createSelector(getHesiNGState, function (state) { return state.studentExamGroupInfo; }),
    getSelectedStudentExam: createSelector(getHesiNGState, function (state) { return state.selectedStudentExam; }),
    getOrderItemSummaryData: createSelector(getHesiNGState, function (state) { return state.orderItemSummaryData; }),
    getExternalCourseSectionId: createSelector(getHesiNGState, function (state) { return state.externalCourseSectionId; }),
    getOrderItemSummaryMessage: createSelector(getHesiNGState, function (state) { return state.orderItemSummaryMessage; }),
    getIsWeakestSubjectAreaCardAndTableSortInteraction: createSelector(getHesiNGState, function (state) { return state.isWeakestSubjectAreaCardAndTableSortInteraction; }),
    getA2StudentPerformance: createSelector(getHesiNGState, function (state) { return state.a2StudentPerformance; }),
    getIsHERItemDetailsLoading: createSelector(getHesiNGState, function (state) { return state.isHERItemDetailsLoading; }),
    getIsHesiNGCategoryDataLoading: createSelector(getHesiNGState, function (state) { return state.isHesiNGCategoryDataLoading; }),
    getIsNGNTabDataLoading: createSelector(getHesiNGState, function (state) { return state.isNGNTabDataLoading; }),
    getIsCategoryLegalDisclaimerDataLoading: createSelector(getHesiNGState, function (state) { return state.isCategoryLegalDisclaimerDataLoading; })
};
export { actions as hesiNgActions, initialState as hesiNgInitialState, reducer as hesiNgReducer, selectors as hesiNgSelectors };
